export default __webpack_public_path__ + "static/icon-operateur-8c9827f35e6850eb6c1cc9fcc1d41b5b.png";